import { CompatibleMessageBundle } from '../MessageBundle';
import WebpackBackend from '../WebpackBackend';
import { bundleNotFoundMessage, novaLocaleToFileExtension, unsupportedBundleMessage } from './util';

/**
 * Important: This class should ONLY be used when there are NO Viya services in your environment.
 *
 * Provides translations for SASDesign-Icon-gui-icu bundle from npm package.
 * To use also install '@sas/i18n-localization-repository'.
 */
export class SASDesignNpmWebpackBackend extends WebpackBackend {
  async import(locale: string, bundleName: string) {
    // Prefer to get en bundles from NovaWebpackBackend. Those will always be in sync with whatever the
    // components need. Getting en from @sas/i18n-localization-repository could result in out of date en
    // bundles if the consumer is not diligent about updating @sas/i18n-localization-repository.
    if (locale === 'en' || bundleName !== 'SASDesign-Icon-gui-icu')
      throw unsupportedBundleMessage(locale, bundleName);
    try {
      return (
        await import(
          `@sas/i18n-localization-repository/bundles/nova/nova-svg/SASDesign-Icon-gui-icu${novaLocaleToFileExtension(
            locale
          )}.properties`
        )
      ).default as CompatibleMessageBundle;
    } catch (e) {
      throw bundleNotFoundMessage(locale, bundleName);
    }
  }
}
